export default {
  chartTitle: 'TỶ TRỌNG GIÁ TRỊ KHỚP LỆNH',
  tooltip: {
    contribution: 'Tỷ trọng',
  },
  valueProprotion: 'Tỷ trọng giá trị khớp lệnh (%)',
  footer:
    'Mỗi ngành bao gồm tất cả cổ phiếu từ HOSE, HNX và UPCOM. (Tỷ trọng giá trị ngành được tính toán dựa trên giá trị khớp lệnh.)',
  listFrequencyByKey: {
    Daily: 'Theo ngày',
    Weekly: 'Theo tuần',
    Monthly: 'Theo tháng',
  },
  rightLabel: 'Tỷ trọng Giá trị (%)',
  listTitleTable: {
    ICB_NAME: 'NGÀNH',
    MARKET_CAP: 'Vốn hóa',
    PERCENT_PRICE_CHANGE_1DAY: '% 1 Ngày',
    PERCENT_PRICE_CHANGE_1WEEK: '% 1 Tuần',
    PERCENT_PRICE_CHANGE_2WEEK: '% 2 Tuần',
    PERCENT_PRICE_CHANGE_1MONTH: '% 1 Tháng',
    PERCENT_PRICE_CHANGE_3MONTH: '% 3 Tháng',
    PERCENT_PRICE_CHANGE_6MONTH: '% 6 Tháng',
    PERCENT_PRICE_CHANGE_9MONTH: '% 9 Tháng',
    PERCENT_PRICE_CHANGE_1YEAR: '% 1 Năm',
    PERCENT_PRICE_CHANGE_YTD: '% YTD',
    AVERAGE_MATCHED_VOLUME_1WEEK: 'KLTB 1 tuần',
    AVERAGE_MATCHED_VOLUME_2WEEK: 'KLTB 2 tuần',
    AVERAGE_MATCHED_VOLUME_1MONTH: 'KLTB 1 tháng',
    AVERAGE_MATCHED_VOLUME_3MONTH: 'KLTB 3 tháng',
  },
  tab: {
    _3_months: '3 Tháng',
    _6_months: '6 Tháng',
    _9_months: '9 Tháng',
    this_year: '1 Năm',
    three_years: '3 Năm',
    five_years: '5 Năm',
  },
};
